import React from 'react';
import MobileMenuSC from './mobile-menu.styled';
import { NavLink } from 'react-router-dom';
import {
  ROUTE_DASHBOARD,
  ROUTE_INVESTMENTS,
  ROUTE_MAILBOX,
  // ROUTE_REQUESTS,
  ROUTE_PROFILE,
  ROUTE_SECONDARY_MARKET,
  // ROUTE_FAQ,
  ROUTE_INVEST_MANAGE_PLAIN,
  ROUTE_EARNINGS_CALCULATOR,
} from '../../../constants';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import { ReactComponent as OverviewIcon } from '../../../assets/img/svg/mobile-menu/overview.svg';
import { ReactComponent as LoanRepayIcon } from '../../../assets/img/svg/mobile-menu/loan-repay.svg';
import { ReactComponent as InvestmentManageIcon } from '../../../assets/img/svg/mobile-menu/investment-manage.svg';
import { ReactComponent as MailboxIcon } from '../../../assets/img/svg/mobile-menu/mailbox.svg';
import { ReactComponent as SecondaryMarketIcon } from '../../../assets/img/svg/mobile-menu/secondary-market.svg';
// import { ReactComponent as RequestsIcon } from '../../../assets/img/svg/mobile-menu/requests.svg';
import { ReactComponent as UserIcon } from '../../../assets/img/svg/user.svg';
import { ReactComponent as LogOutIcon } from '../../../assets/img/svg/log-out.svg';
import { ReactComponent as GuaranteeFund } from '../../../assets/img/svg/guarantee-fund.svg';
import useWindowSize from '../../../utils/screen-size';

// import { ReactComponent as FaqIcon } from '../../../assets/img/svg/mobile-menu/faq.svg';

const MobileMenu = ({
  isMobileMenuOpen,
  isUserOnboardingInvestor,
  isUserOnboardingDebtor,
  isUserOnboardingOnline,
  isUserInvestor,
  onCloseClick,
  isUserRegistered,
  userName,
  onLogout,
  history,
}) => {
  const { isMobile } = useWindowSize();

  const onProfile = () => {
    onCloseClick();
    history.push(ROUTE_PROFILE);
  };

  return (
    <MobileMenuSC className={isMobileMenuOpen ? 'active' : ''}>
      <div className="mobile-menu-inner-wrap">
        <NavLink exact to={ROUTE_DASHBOARD} activeClassName="active" onClick={() => onCloseClick()}>
          {isUserOnboardingInvestor || isUserOnboardingDebtor || isUserOnboardingOnline ? (
            <FormattedMessage id="menu_registration" defaultMessage={dlt['menu_registration']} />
          ) : (
            <FormattedMessage
              id={isUserInvestor ? 'menu_overview' : 'menu_loan_overview'}
              defaultMessage={isUserInvestor ? dlt['menu_overview'] : dlt['menu_loan_overview']}
            />
          )}
          <span className="icon-wrap">
            {' '}
            <OverviewIcon />
          </span>
        </NavLink>
        {isUserOnboardingInvestor ? (
          <NavLink
            exact
            to={ROUTE_EARNINGS_CALCULATOR}
            activeClassName="active"
            onClick={() => onCloseClick()}
          >
            <FormattedMessage
              id="menu_earnings_calculator"
              defaultMessage={dlt['menu_earnings_calculator']}
            />
            <span className="icon-wrap">
              {' '}
              <InvestmentManageIcon />
            </span>
          </NavLink>
        ) : null}

        {isUserInvestor && isUserRegistered ? (
          <>
            <NavLink to={ROUTE_INVESTMENTS} activeClassName="active" onClick={() => onCloseClick()}>
              <FormattedMessage
                id="menu_my_investments"
                defaultMessage={dlt['menu_my_investments']}
              />
              <span className="icon-wrap">
                <LoanRepayIcon />
              </span>
            </NavLink>
            <NavLink
              exact
              to={ROUTE_INVEST_MANAGE_PLAIN}
              activeClassName="active"
              onClick={() => onCloseClick()}
            >
              <FormattedMessage
                id="menu_investment_manage"
                defaultMessage={dlt['menu_investment_manage']}
              />
              <span className="icon-wrap">
                <InvestmentManageIcon />
              </span>
            </NavLink>
            <NavLink
              exact
              to="/guarantee-fund"
              activeClassName="active"
              onClick={() => onCloseClick()}
            >
              <FormattedMessage
                id="menu_guarantee_fund"
                defaultMessage={dlt['menu_guarantee_fund']}
              />
              <span className="icon-wrap">
                <GuaranteeFund />
              </span>
            </NavLink>
          </>
        ) : null}

        {isUserRegistered ? (
          <>
            {isUserInvestor ? (
              <>
                <NavLink
                  exact
                  to={ROUTE_SECONDARY_MARKET}
                  activeClassName="active"
                  onClick={() => onCloseClick()}
                >
                  <FormattedMessage
                    id="menu_secondary_market"
                    defaultMessage={dlt['menu_secondary_market']}
                  />
                  <span className="icon-wrap">
                    <SecondaryMarketIcon />
                  </span>
                </NavLink>

                {/* <NavLink
                  exact
                  to={ROUTE_REQUESTS}
                  activeClassName="active"
                  onClick={() => onCloseClick()}
                >
                  <FormattedMessage id="menu_requests" defaultMessage={dlt['menu_requests']} />
                  <span className="icon-wrap">
                    <RequestsIcon />
                  </span>
                </NavLink> */}
              </>
            ) : (
              <></>
              // <NavLink
              //   exact
              //   to={ROUTE_REQUESTS}
              //   activeClassName="active"
              //   onClick={() => onCloseClick()}
              // >
              //   <FormattedMessage id="menu_requests" defaultMessage={dlt['menu_requests']} />
              //   <span className="icon-wrap">
              //     <RequestsIcon />
              //   </span>
              // </NavLink>
            )}

            {/*  <NavLink to={ROUTE_FAQ} activeClassName="active" onClick={() => onCloseClick()}>
              <FormattedMessage id="menu_faq" defaultMessage={dlt['menu_faq']} />
              <span className="icon-wrap">
                <FaqIcon />
              </span>
            </NavLink> */}
          </>
        ) : null}
        {isMobile ? (
          <>
            <div className="separator"></div>
            <NavLink
              exact
              to={ROUTE_MAILBOX}
              activeClassName="active"
              onClick={() => onCloseClick()}
            >
              <FormattedMessage id="menu_mailbox" defaultMessage={dlt['menu_mailbox']} />
              <span className="icon-wrap">
                <MailboxIcon />
              </span>
            </NavLink>
            <button className="user-btn profile" onClick={() => onProfile()}>
              <span className="special-colored">{userName ? userName : null}</span>
              <span className="icon-wrap">
                <UserIcon />
              </span>
            </button>
            <button className="user-btn logout" onClick={() => onLogout()}>
              <FormattedMessage id="global_log_out" defaultMessage={dlt['global_log_out']} />

              <span className="icon-wrap">
                <LogOutIcon />
              </span>
            </button>
          </>
        ) : null}
      </div>
    </MobileMenuSC>
  );
};

export default withRouter(MobileMenu);
